import styled from 'styled-components';

export const Message = styled.div`
position: absolute;
width: 100%;
height: 100%;
top: 0;
left: 0;
z-index: 1;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
color: black;
font-size: 1em;

div {
  background-color: white;
  outline: solid 3px blue;
  width: 95%;
  height: 30%;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    text-align: center;
    margin: 2rem 0rem;
  }

  div {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20%;
  outline: none;

  button {
    background-color: #024089;
  }
}
}
`;
